import keycloakAxios from '@/services/axios';

export const getUserByMail = async (mail: string) => {
  const response = await keycloakAxios.get(`user/by-email/${mail}`);

  if (response.status >= 300) {
    throw new Error(
      `Error getting user data: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
